import { render, staticRenderFns } from "./CenterViewEventDesignUpload_Ap.vue?vue&type=template&id=1f54ce0a&scoped=true"
import script from "./CenterViewEventDesignUpload_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventDesignUpload_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventDesignUpload_Ap.vue?vue&type=style&index=0&id=1f54ce0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f54ce0a",
  null
  
)

export default component.exports